import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { nextYears } from '../../../../utils/dates';

function ReportsAggregatorMetricsModalForm({
  setSpinner,
  close,
  createReport,
  aggregators,
  getAggregators,
}) {
  const [form, setForm] = useState({
    aggregatorId: '',
    fromYear: '',
    fromMonth: '',
    toYear: '',
    toMonth: '',
  });

  useEffect(() => {
    (async () => {
      setSpinner(true);
      await getAggregators();
      setSpinner(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreate = () => {
    const { aggregatorId, fromMonth, fromYear, toMonth, toYear } = form;

    createReport({
      aggregatorId: aggregatorId ? Number(aggregatorId) : null,
      fromMonth: Number(fromMonth),
      fromYear: Number(fromYear),
      toMonth: Number(toMonth),
      toYear: Number(toYear),
    });
  };

  return (
    <>
      <Row className="align-items-center">
        <Col md={4} className="bo-same-line">
          <Form.Label>Aggregator:</Form.Label>
        </Col>
        <Col md={8} className="bo-same-line">
          <Form.Select
            className="bo-filter bo-w-250"
            value={form.aggregatorId}
            onChange={e => setForm(prev => ({ ...prev, aggregatorId: e.target.value }))}
          >
            <option value="">All Standard Aggregators</option>
            {aggregators.map(agg => (
              <option key={agg.id} value={agg.id}>
                {agg.name}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="mt-2 mb-2 align-items-center">
        <Col md={4} className="bo-same-line">
          <Form.Label>From:</Form.Label>
        </Col>
        <Col md={8} className="bo-same-line gap-1 bo-w-274">
          <Form.Select
            className="bo-filter text-truncate w-100"
            value={form.fromMonth}
            onChange={e => setForm(prev => ({ ...prev, fromMonth: e.target.value }))}
          >
            <option value="">Month</option>
            {[...Array(12).keys()].map(m => (
              <option key={m} value={m + 1}>
                {m + 1}
              </option>
            ))}
          </Form.Select>
          <Form.Select
            className="bo-filter text-truncate w-100"
            value={form.fromYear}
            onChange={e => setForm(prev => ({ ...prev, fromYear: e.target.value }))}
          >
            <option value="">Year</option>
            {nextYears(8, 2023).map(y => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="mt-0 mb-2 align-items-center">
        <Col md={4} className="bo-same-line">
          <Form.Label>To:</Form.Label>
        </Col>
        <Col md={8} className="bo-same-line gap-1 bo-w-274">
          <Form.Select
            className="bo-filter text-truncate w-100"
            value={form.toMonth}
            onChange={e => setForm(prev => ({ ...prev, toMonth: e.target.value }))}
          >
            <option value="">Month</option>
            {[...Array(12).keys()].map(m => (
              <option key={m} value={m + 1}>
                {m + 1}
              </option>
            ))}
          </Form.Select>
          <Form.Select
            className="bo-filter text-truncate w-100"
            value={form.toYear}
            onChange={e => setForm(prev => ({ ...prev, toYear: e.target.value }))}
          >
            <option value="">Year</option>
            {nextYears(8, 2023).map(y => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="mt-auto">
        <Col className="d-flex justify-content-center gap-3">
          <Button
            className="bo-button"
            onClick={handleCreate}
            disabled={!form.fromMonth || !form.fromYear || !form.toMonth || !form.toYear}
          >
            Create
          </Button>
          <Button className="bo-button" onClick={close}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default ReportsAggregatorMetricsModalForm;
